import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'vue-emoji-picker/dist/vue-emoji-picker.css';
import App from './App.vue'
import router from './router' 
import '@/assets/global.css'
import { createPinia } from 'pinia';
const app = createApp(App)
const pinia = createPinia();
app.use(ElementPlus)
app.use(router)
app.use(pinia);
app.mount('#app');
